// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SkeletonElement } from "@eisinc/App/Components/Skeleton/Skeleton";
import { xScreen } from "@eisinc/XDL/Utilities";
import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import { css } from "styled-components";

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            height: auto;
            max-width: 100%;
        }
        ${SkeletonElement} {
            aspect-ratio: 1;
            ${xScreen("lte", "md")} {
                margin-bottom: 12px;
            }
        }
    `,
};
